<!--
 * @Author: ZhaoG
 * @Date: 2026-03-20 15:30:00
 * @Description: 文件列表弹窗组件（可复用）
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="1000px"
    :before-close="handleClose"
  >
    <el-table :data="fileList" border style="width: 100%">
      <!-- 文件名称 -->
      <el-table-column
        prop="fileName"
        :label="$t('page.greenLowCarbon.table.fileName')"
        show-overflow-tooltip
      ></el-table-column>

      <!-- 文件大小 -->
      <el-table-column
        prop="fileSize"
        :label="$t('page.greenLowCarbon.table.fileSize')"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatFileSize(scope.row.fileSize) }}
        </template>
      </el-table-column>

      <!-- 操作栏 -->
      <el-table-column
        :label="$t('page.greenLowCarbon.table.operation')"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="handlePreview(scope.row)"
          >
            {{ $t("page.greenLowCarbon.table.preview") }}
          </el-button>
          <el-button type="text" size="mini" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
          <el-button
            type="text"
            size="mini" v-if="type==1"
            @click="handleDelete(scope.$index, scope.row)"
          >
            {{ $t("page.greenLowCarbon.table.delete") }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("page.greenLowCarbon.info.cancel") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "FileListDialog",
  props: {
    // 弹窗显示状态
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    // 文件列表数据
    fileList: {
      type: Array,
      default: () => []
    },
    // 弹窗标题
    title: {
      type: String,
      default: "文件列表"
    },
    type:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  watch: {
    dialogFormVisible: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true
    },
    dialogVisible: {
      handler(newVal) {
        this.$emit("update:dialogFormVisible", newVal);
      }
    }
  },
  methods: {
    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    // 预览文件
    async handlePreview(row) {
      try {
        this.$emit("handlePreview", row);
      } catch (error) {
        this.$message.error("预览失败");
      }
    },

    // 下载文件
    downloadFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sra/reg/users/signup/downloadByFileUrl?fileUrl=${
        row.ossUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },

    // 删除文件
    handleDelete(index, row) {
      // this.$confirm("确定要删除该文件吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // }).then(() => {
        this.$emit("handleDelete", { index, row });
      // }).catch(() => {});
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$emit("handleClose");
    },

  }
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: center;
}
</style>
